export const actions = {
    increment({ commit }, data) {
        commit('incrementCounter', data);
    },
    reset({ commit }) {
        commit('resetCounter');
    },
    updateClientId({ commit }, clientId) {
        commit('updateClientId', clientId);
    },
    updateCompanyId({ commit }, companyId) {
        commit('updateCompanyId', companyId);
    },
    updateEnvironmentName({ commit }, timezone) {
        commit('updateEnvironmentName', timezone);
    },
    updateDirtyPageValidation({ commit }, pageValidation) {
        commit('updateDirtyPageValidation', pageValidation);
    },
    resetDirtyPageValidation({ commit }) {
        commit('resetDirtyPageValidation');
    },
    updateIsSelectable({ commit }, isSelectable) {
        commit('updateIsSelectable', isSelectable);
    },
    updateSelectedAudienceID({ commit }, selectedAudienceID) {
        commit('updateSelectedAudienceID', selectedAudienceID);
    },
};
//# sourceMappingURL=actions.js.map